import React, { useState } from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";

import { CommonDialog, CommonDialogContent, CommonDialogTitle } from "../../common/dialogs";
import { SearchInput } from "../../common/form-controls";

import PersistedRolesTable from "../persisted-roles-table";
import { Box } from "@mui/material";

const GroupRoleAddRolesDialog = ({ open, systemId, onClose, onSubmit, showSingleRoles, getRoles, selectComponent = null }) => {
    const intl = useIntl();
    const [searchString, setSearchString] = useState("");

    const columns = [
        {
            id: "role",
            title: intl.formatMessage({ id: "add-role-dialog.columns.key" }),
        },
        {
            id: "description",
            title: intl.formatMessage({ id: "add-role-dialog.columns.text" }),
        },
    ];

    return (
        <CommonDialog className="group-role-add-roles-dialog" open={open}>
            <CommonDialogTitle title={intl.formatMessage({ id: "user-level-modeling.role-search-help-dialog.toolbar.add" })} onClose={onClose} />
            <CommonDialogContent>
                {selectComponent ? (
                    <Box display="flex" justifyContent="center" alignItems="center" gap={2} sx={{ width: "100%"}}>
                        <Box flexGrow={1} sx={{ marginTop: "16.5px" }}>
                            <SearchInput
                                value={searchString}
                                onSearchClick={(event) => setSearchString(event.target.value)}
                                fullWidth
                                sx={{ marginTop: "13px", height: 40, minHeight: 40 }}
                            />
                        </Box>
                        {selectComponent && <Box sx={{}}>{selectComponent}</Box>}
                    </Box>
                ) : (
                    <SearchInput value={searchString} onSearchClick={(event) => setSearchString(event.target.value)} />
                )}

                <PersistedRolesTable
                    columns={columns}
                    systemId={systemId}
                    searchString={searchString}
                    onRowClick={onSubmit}
                    showSingleRoles={showSingleRoles}
                    getRoles={getRoles}
                />
            </CommonDialogContent>
        </CommonDialog>
    );
};

GroupRoleAddRolesDialog.propTypes = {
    open: PropTypes.bool,
    systemId: PropTypes.string,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    getRoles: PropTypes.func,
    showSingleRoles: PropTypes.bool,
    selectComponent: PropTypes.node,
};

export default GroupRoleAddRolesDialog;
